import React from 'react';
import PropTypes from 'prop-types';
import Input from 'Validation/Input';
import classNames from 'classnames';


class BaseFormRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFocused: false,
      showError: false,
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onShowError = this.onShowError.bind(this);
    this.onHideError = this.onHideError.bind(this);
  }

  onFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
    this.setState({
      isFocused: true,
    });
  }

  onBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
    this.setState({
      isFocused: false,
    });
  }

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  onShowError() {
    this.setState({
      showError: true,
    });
  }

  onHideError() {
    this.setState({
      showError: false,
    });
  }

  render() {
    const validationProps = this.props.validationProps;
    if (this.props.stateKey) {
      validationProps['data-statekey'] = this.props.stateKey;
    }

    const labelClassName = `control-label ${this.props.labelClasses}`;
    const inputWrapperClassName = `input ${this.props.inputClasses}`;
    const formRowClassName = classNames(
      `form-row ${this.props.formClasses}`,
      {
        focus: this.state.isFocused,
        'is-invalid-input': this.state.showError,
      },
    );

    return (
      <div className={formRowClassName}>
        <label
          htmlFor={this.props.htmlFor}
          className={labelClassName}
        >
          {this.props.label}
        </label>
        <div className={inputWrapperClassName}>
          <Input
            {...validationProps}
            handleOnChange={this.onChange}
            handleOnBlur={this.onBlur}
            handleOnFocus={this.onFocus}
            onHideError={this.onHideError}
            onShowError={this.onShowError}
          />
          {this.props.children}
        </div>
      </div>
    );
  }
}

BaseFormRow.defaultProps = {
  formClasses: '',
  stateKey: '',
  inputClasses: '',
  children: null,
  labelClasses: '',
  handleInputChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
};

BaseFormRow.propTypes = {
  formClasses: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelClasses: PropTypes.string,
  inputClasses: PropTypes.string,
  stateKey: PropTypes.string,
  validationProps: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    maxLength: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    validations: PropTypes.arrayOf(PropTypes.func),
    onChange: PropTypes.func,
  }).isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  children: PropTypes.node,
};

export default BaseFormRow;



// WEBPACK FOOTER //
// ./src-react/CheckoutForm/components/FormRow/BaseFormRow.jsx